<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>
              Danh sách đơn hàng
              <xlsx-workbook class="btn-icon ml-1 float-right">
                <xlsx-sheet
                    v-for="sheet in sheets"
                    :key="sheet.name"
                    :collection="sheet.data"
                    :sheet-name="sheet.name"
                    role="button"
                />
                <xlsx-download>
                  <feather-icon icon="DownloadIcon" role="button"/>
                  <span class=" small " role="button">Tải file</span>
                </xlsx-download>
              </xlsx-workbook>
              <!--<export-excel
                v-b-tooltip.hover.top="'Export excel!'"
                class   = "btn-icon ml-1"
                :data   = "rows_excel"
                worksheet = "My Worksheet"
                rolt    = "button"
                id="export-excel"
                name    = "shopee-order.xls"><feather-icon icon="DownloadIcon"/></export-excel>-->
              <span class="float-right">
                <a
                    v-b-tooltip.hover.top="'Đồng bộ và ghép số!'"
                    class="btn-icon ml-1 text-sm"
                    @click="shopeeSync()"
                ><feather-icon icon="RepeatIcon"/>
                  <span class="small">Đồng bộ và ghép số</span></a
                >
              </span>
            </h4>
          </b-col>
          <b-col cols="12">
            <b-tabs>
              <b-tab active title="All" @click="changeTab(null)"></b-tab>
              <b-tab title="UNPAID" @click="changeTab('UNPAID')"></b-tab>
              <b-tab title="READY_TO_SHIP" @click="changeTab('READY_TO_SHIP')">
              </b-tab>
              <b-tab title="PROCESSED" @click="changeTab('PROCESSED')"></b-tab>
              <b-tab title="SHIPPED" @click="changeTab('SHIPPED')"></b-tab>
              <b-tab title="COMPLETED" @click="changeTab('COMPLETED')"></b-tab>

              <b-tab title="IN_CANCEL" @click="changeTab('IN_CANCEL')"></b-tab>
              <b-tab title="CANCELLED" @click="changeTab('CANCELLED')"></b-tab>
              <b-tab
                  title="INVOICE_PENDING"
                  @click="changeTab('INVOICE_PENDING')"
              >
              </b-tab>
            </b-tabs>
          </b-col>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{
                perPage: serverParams.pageSize,
                enabled: true,
                perPageDropdown: [20, 50, 100],
                dropdownAllowAll: false
              }"
                :rows="rows"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <b-dropdown
                      no-caret
                      size="sm"
                      toggle-class="text-decoration-none"
                      variant="link"
                  >
                    <template v-slot:button-content>
                      <feather-icon
                          class="text-body align-middle mr-25"
                          icon="MoreVerticalIcon"
                          size="16"
                      />
                    </template>
                    <b-dropdown-item @click="view(props.index)">
                      <feather-icon class="mr-50" icon="EyeIcon"/><span
                    >Xem chi tiết</span
                    >
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-else-if="props.column.field === 'TotalPrice'">
                  {{ props.formattedRow[props.column.field] | number }}
                </span>
                <span v-else-if="props.column.field === 'Devices'">
                  <span v-html="getDeviceName(props.row)"/>
                </span>
                <span v-else-if="props.column.field === 'id'">
                  <a class="font-weight-bold" @click="view(props.index)">{{
                    props.row.id
                  }}</a>
                </span>
                <span v-else-if="props.column.field === 'PaymentChannel'">
                  <a class="text">{{
                    props.row.PaymentChannel == "BANKTRANFER"
                      ? "Chuyển khoản"
                      : props.row.PaymentChannel
                  }}</a>
                </span>
                <span v-else-if="props.column.field === 'GHTK_Id'">
                  <a
                      v-if="
                      props.row && props.row.IsFast == 1 && props.row.J_Shipment
                    "
                      :href="props.row.J_Shipment.shared_link"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                  <a
                      v-else
                      :href="'https://i.ghtk.vn/' + props.row.GHTK_Id"
                      target="_blank"
                  >{{ props.row.GHTK_Id }}</a
                  >
                </span>
                <span v-else-if="props.column.field === 'order_status'">
                  <span
                      v-if="statusList.find(m => m.id == props.row.order_status)"
                      class="badge badge-light-info"
                  >{{
                      statusList.find(m => m.id == props.row.order_status).text
                    }}</span
                  >
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
        id="modal-view"
        :title="'Thông tin đơn hàng ' + currentItem.id"
        ok-only
        size="xl"
        @hide="handleHide"
        @ok="handleOk"
    >
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="12">
            <h4 class="pt-2">Danh sách sim</h4>
            <div v-if="currentItem && currentItem.details" class="">
              <table class="table table-sm table-bordered table-striped">
                <tr>
                  <th>Tên sản phẩm</th>
                  <th>Biến thể</th>
                  <th>Giá gốc</th>
                  <th>shopee KM</th>
                  <th>iTel KM</th>
                  <th>Giá bán</th>
                  <th>Số iTel</th>
                  <th>Serial</th>
                  <th>Mã vận đơn</th>
                  <!-- <th>Phí vận chuyển</th> -->
                </tr>
                <tr v-for="(i, stt) in currentItem.details" :key="stt">
                  <td class="text-primary">{{ i.product_name }}</td>
                  <td>{{ i.sku_name }}</td>
                  <td>{{ i.original_price | number }} đ</td>
                  <td>{{ i.platform_discount | number }} đ</td>
                  <td>{{ i.seller_discount | number }} đ</td>
                  <td>{{ i.sale_price | number }} đ</td>
                  <td>{{ i.itel_phone }}</td>
                  <td>{{ i.itel_serial }}</td>
                  <td>{{ i.tracking_number }}</td>
                </tr>
              </table>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-dktt"
        :title="'Thông tin lịch sử đăng ký TTTB'"
        ok-only
        size="xl"
    >
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import SearchSelect from "../components/select/SearchSelect.vue";
import Vue from "vue";
import excel from "vue-excel-export";
import {XlsxDownload, XlsxSheet, XlsxWorkbook} from "vue-xlsx";

Vue.use(excel);

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect,
    XlsxDownload,
    XlsxSheet,
    XlsxWorkbook
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple
  },
  mounted() {
    this.loadMasterData();
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {
    /*viewDKTTHist(p){
      console.log(p);
      this.dkttRows = p.reg_hist;
      this.$bvModal.show('modal-dktt');
    },*/
    shopeeSync() {
      this.isLoading = true;
      this.loading(true);
      useJwt
          .get("shopee/process")
          .then(response => {
            this.isLoading = false;
            this.loading(false);
            this.loadItems();
          })
          .catch(error => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    exportExcel() {
    },
    dateFormat(v) {
      return moment(v, "YYYYMMDDHHmmss").format("DD/MM/YYYY hh:mm:ss");
    },
    changeTab(i) {
      this.serverParams.columnFilters.searchString = null;
      this.serverParams.columnFilters.order_status = i;
      this.loadItems();
    },
    quickSearch() {
      this.serverParams.columnFilters.status = null;
      this.serverParams.columnFilters.searchString = this.searchString;
      this.loadItems();
    },
    loadMasterData() {
      this.loadItems();
      //this.fetchCities();
      //this.fetchStores();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (this.serverParams.columnFilters.CreateDate_) {
        this.serverParams.columnFilters.FromDate = this.serverParams.columnFilters.CreateDate_;
        this.serverParams.columnFilters.ToDate = this.serverParams.columnFilters.CreateDate_;
      } else {
        if (this.serverParams.columnFilters.FromDate) {
          delete this.serverParams.columnFilters["FromDate"];
        }
        if (this.serverParams.columnFilters.ToDate) {
          delete this.serverParams.columnFilters["ToDate"];
        }
      }
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters
              ? this.serverParams.columnFilters
              : [])
        }
      };
      if (data.columnFilters.CreateDate_ != undefined) {
        delete data.columnFilters["CreateDate_"];
      }
      useJwt
          .post("shopee/order-list", data)
          .then(response => {
            this.rows = response.data.result;
            //console.log(this.rows)
            this.totalRecords = response.data.totalRecords;
            this.rows_excel = response.data.extra.excel;
            //console.log(this.sheets[0]);
            if (this.rows_excel.length > 0) {
              this.sheets[0].data = this.rows_excel;
            }
            //this.sheets[0].data = this.rows_excel;
            this.isLoading = false;
            this.loading(false);
          })
          .catch(error => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    viewUpdateShipment(idx) {
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.$bvModal.show("modal-shipment");
      this.isLoading = false;
    },
    viewChangetstaus(idx) {
      this.currentItem.newStatus = this.currentItem.Status;
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.$bvModal.show("modal-change-status");
      this.isLoading = false;
    },

    view(idx) {
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.loading(false);
      this.$bvModal.show("modal-view");
      this.isLoading = false;
    },
    async handleOk(bvModalEvt) {
    },
    handleHide() {
    }
  },
  data() {
    return {
      isEditPhoneEmail: false,
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      shipment_id: "",
      rows: [],
      rows_excel: [],
      //dkttRows:[],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: "",
      currentItem: {},
      Cities: [],
      Districts: [],
      Wards: [],
      Stores: [],
      hamlets: [],
      fields: [
        {
          field: "id",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Mã đơn hàng",
          width: "150px"
        },
        {
          field: "create_time_",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Ngày tạo",
          width: "100px"
        },
        {
          field: "name",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Họ tên KH"
        },
        {
          field: "phone",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số ĐT KH"
        },
        {
          field: "full_address",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Địa chỉ",
          tdClass: "mw-350"
        },
        {
          field: "buyer_message",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "KH ghi chú"
        },
        {
          field: "order_status",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: "UNPAID", text: "UNPAID"},
              {value: "READY_TO_SHIP", text: "READY_TO_SHIP"},
              {value: "PROCESSED", text: "PROCESSED"},
              {value: "SHIPPED", text: "SHIPPED"},
              {value: "COMPLETED", text: "COMPLETED"},
              {value: "IN_CANCEL", text: "IN_CANCEL"},
              {value: "CANCELLED", text: "CANCELLED"},
              {value: "INVOICE_PENDING", text: "INVOICE_PENDING"}
            ]
          },
          label: "Tình trạng?"
        },
        {field: "action", label: "Thao tác", width: "80px"}
      ],
      statusList: [
        {id: "UNPAID", text: "UNPAID"},
        {id: "READY_TO_SHIP", text: "READY_TO_SHIP"},
        {id: "PROCESSED", text: "PROCESSED"},
        {id: "SHIPPED", text: "SHIPPED"},
        {id: "COMPLETED", text: "COMPLETED"},
        {id: "IN_CANCEL", text: "IN_CANCEL"},
        {id: "CANCELLED", text: "CANCELLED"},
        {id: "INVOICE_PENDING", text: "INVOICE_PENDING"}
      ],
      vnPayErrors: [
        {id: "00", text: "Giao dịch thành công"},
        {
          id: "07",
          text:
              "Trừ tiền thành công. Giao dịch bị nghi ngờ (liên quan tới lừa đảo, giao dịch bất thường)."
        },
        {
          id: "09",
          text:
              "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng chưa đăng ký dịch vụ InternetBanking tại ngân hàng."
        },
        {
          id: "10",
          text:
              "Giao dịch không thành công do: Khách hàng xác thực thông tin thẻ/tài khoản không đúng quá 3 lần"
        },
        {
          id: "11",
          text:
              "Giao dịch không thành công do: Đã hết hạn chờ thanh toán. Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {
          id: "12",
          text:
              "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng bị khóa."
        },
        {
          id: "13",
          text:
              "Giao dịch không thành công do Quý khách nhập sai mật khẩu xác thực giao dịch (OTP). Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {
          id: "24",
          text: "Giao dịch không thành công do: Khách hàng hủy giao dịch"
        },
        {
          id: "51",
          text:
              "Giao dịch không thành công do: Tài khoản của quý khách không đủ số dư để thực hiện giao dịch."
        },
        {
          id: "65",
          text:
              "Giao dịch không thành công do: Tài khoản của Quý khách đã vượt quá hạn mức giao dịch trong ngày."
        },
        {id: "75", text: "Ngân hàng thanh toán đang bảo trì."},
        {
          id: "79",
          text:
              "Giao dịch không thành công do: KH nhập sai mật khẩu thanh toán quá số lần quy định. Xin quý khách vui lòng thực hiện lại giao dịch"
        },
        {
          id: "99",
          text: "Lỗi thanh toán ngân hàng, quý khách vui lòng thử lại"
        }
      ],
      ahmStatus: [
        {id: "IDLE", text: "Đã tiếp nhận"},
        {id: "ASSIGNING", text: "Đã điều phối lấy hàng"},
        {id: "ACCEPTED", text: "Đã tiếp nhận"},
        {id: "IN PROCESS", text: "Shipper báo đã lấy hàng"},
        {id: "COMPLETED", text: "Hoàn thành đơn hàng"},
        {id: "CANCELLED", text: "Hủy đơn hàng"}
      ],
      ghtkStatus: [
        {id: "-1", text: "Hủy đơn hàng"},
        {id: "1", text: "Chưa tiếp nhận"},
        {id: "2", text: "Đã tiếp nhận"},
        {id: "3", text: "Đã lấy hàng/Đã nhập kho"},
        {id: "4", text: "Đã điều phối giao hàng/Đang giao hàng"},
        {id: "5", text: "Đã giao hàng/Chưa đối soát"},
        {id: "6", text: "Đã đối soát"},
        {id: "7", text: "Không lấy được hàng"},
        {id: "8", text: "Hoãn lấy hàng"},
        {id: "9", text: "Không giao được hàng"},
        {id: "10", text: "Delay giao hàng"},
        {id: "11", text: "Đã đối soát công nợ trả hàng"},
        {id: "12", text: "Đã điều phối lấy hàng/Đang lấy hàng"},
        {id: "13", text: "Đơn hàng bồi hoàn"},
        {id: "20", text: "Đang trả hàng (COD cầm hàng đi trả)"},
        {id: "21", text: "Đã trả hàng (COD đã trả xong hàng)"},
        {id: "123", text: "Shipper báo đã lấy hàng"},
        {
          id: "127",
          text: "Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng"
        },
        {id: "128", text: "Shipper báo delay lấy hàng"},
        {id: "45", text: "Shipper báo đã giao hàng"},
        {id: "49", text: "Shipper báo không giao được giao hàng"},
        {id: "410", text: "Shipper báo delay giao hàng"}
      ],
      serverParams: {
        columnFilters: {},
        sort: [{field: "create_time", type: "desc"}],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      sheets: [{name: "Dữ liệu - shopee", data: [{c: 1}]}],
      required
    };
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style>
.b2c-order .vgt-wrap {
  max-height: calc(100vh - 300px);
  overflow: auto;
}

.font-small .table-sm {
  font-size: 11px;
}

.col-gap-1 {
  column-gap: 1rem;
}

.vgt-responsive {
  min-height: 300px;
}

#export-excel {
  display: inline;
}

.mw-350 {
  max-width: 350px !important;
}
</style>
